import api from './http';

export const getRegistryEntries = (params) => api.get('/adhesion/registry/entries', { params });
export const getRegistryTemplate = () => api.get('/adhesion/registry/template', { responseType: 'blob' });
export const previewRegistryImport = (file) => {
  const data = new FormData(); data.append('file', file);
  return api.post('/adhesion/registry/imports/preview', data, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const confirmRegistryImport = (id) => api.post(`/adhesion/registry/imports/${encodeURIComponent(id)}/confirm`);
export const getRegistryImport = (id) => api.get(`/adhesion/registry/imports/${encodeURIComponent(id)}`);

export const saveRegistryFile = (blob, filename) => {
  const url = URL.createObjectURL(blob); const link = document.createElement('a');
  link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const registryError = async (error) => {
  let data = error?.response?.data;
  if (data instanceof Blob) { try { data = JSON.parse(await data.text()); } catch { data = null; } }
  return typeof data?.detail === 'string' ? data.detail : 'Opération impossible. Veuillez réessayer.';
};